import React from 'react'
import styled from '@emotion/styled'

const TagContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 5px 8px;
  border-radius: 50px;
  border: 0.5px solid black;
  font-size: 12px;
  align-self: start;
`

const Flag = styled.img`
  margin-right: 5px;
  width: auto;
  height: 10px;
`

const Close = styled.img`
  margin-left: 5px;
  width: 14px;
  height: 14px;
  cursor: pointer;
`

const CountryTag = () => {

  return (
    <TagContainer>
      <Flag src="https://cdn-icons-png.flaticon.com/512/197/197571.png" />
      <span>Germany</span>
      <Close src="https://cdn-icons-png.flaticon.com/512/9974/9974058.png"/>
    </TagContainer>
  )
}

export default CountryTag